import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";

import './dropDownMenu.scss';

function DropDownMenuPost(props) {
  const [click, setClick] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => setClick(!click);
  const pageLanguageContents = props.content
  const userType = localStorage.getItem('accountType')

  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg = storedData?.guestUser

  let MenuItems;
  if(disableFlg){
    MenuItems = [
      {
        title: pageLanguageContents?.Header[18]?.H_MyPostedNeeds,
        // path: '/MyPostLoad?postType=PostLoad&type=postedNeeds&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
        path: '/my-posted-pallet-needs',
        cName: 'dropdown-link'
      },
      {
        title: pageLanguageContents?.Header[19]?.H_MyPostedInventory,
        //path: '/MyInventories?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=panel2',
        path: '/my-posted-pallet-inventory',
        cName: 'dropdown-link'
      }
    ];
  }else{
    if (userType === "Both") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[18]?.H_MyPostedNeeds,
          // path: '/MyPostLoad?postType=PostLoad&type=postedNeeds&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
          path: '/my-posted-pallet-needs',
          cName: 'dropdown-link'
        },
        {
          title: pageLanguageContents?.Header[19]?.H_MyPostedInventory,
          //path: '/MyInventories?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=panel2',
          path: '/my-posted-pallet-inventory',
          cName: 'dropdown-link'
        }
      ];
    }
    else if (userType === "Seller") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[19]?.H_MyPostedInventory,
          //path: '/MyInventories?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=panel2',
          path: '/my-posted-pallet-inventory',
          cName: 'dropdown-link'
        }
      ];
    }
    else if (userType === "Buyer") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[18]?.H_MyPostedNeeds,
          path: '/my-posted-pallet-needs',
          cName: 'dropdown-link'
        }
      ];
    } else {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[18]?.H_MyPostedNeeds,
          //path: '/MyPostLoad?postType=PostLoad&type=postedNeeds&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
          path: '/my-posted-pallet-needs',
          cName: 'dropdown-link'
        },
        {
          title: pageLanguageContents?.Header[19]?.H_MyPostedInventory,
          // path: '/MyInventories?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=panel2',
          path: '/my-posted-pallet-inventory',
          cName: 'dropdown-link'
        }
      ];
    }
  }
 

  const onLinkClick = (type) => {
    let paginationObj = {
      selectedPage: 1,
    }
    dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
    //path: '/my-posted-pallet-needs?postType=PostLoad&type=postedNeeds&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
    if (type === 'MyPostLoad') {
      let obj = {
        postType: "PostLoad",
        type: "postedNeeds",
        activePage: 'PostLoad',
        activeSearch: 'Dashboard',
        expanded: 'panel1'
      }
      dispatch({ type: 'CREATED_NEEDS', payload: obj })
    }
    //path: '/my-posted-pallet-inventory?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=panel2',
    if (type === 'MyInventories') {
      let obj = {
        postType: "PostInventory",
        type: "palletOffers",
        activePage: 'PostInventory',
        // activeSearch:'Dashboard',
        expanded: 'panel2'
      }
      dispatch({ type: 'CREATED_INVENTORY', payload: obj })
    }
  };

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
               { disableFlg? <div
                className='opacityDisable'
              >
                <img
                  className="arrow-image"
                  src={HoverRightArrow}
                  alt="right-arrow"
                />
                {item.title}
              </div>:
              <Link
                className={item.cName}
                exact
                to={item.path}
                onClick={() => onLinkClick(item.type)}
              >
                <img
                  className="arrow-image"
                  src={HoverRightArrow}
                  alt="right-arrow"
                />
                {item.title}
              </Link>}
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenuPost;